import * as react from "react";
import { DOMAttr, HTMLAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { Internal_updateInputValue } from "./fable_modules/Fable.Elmish.React.5.0.0/./common.fs.js";
import { map as map_1, empty, singleton, append, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import { printf, toText, isNullOrWhiteSpace } from "./fable_modules/fable-library.4.10.0/String.js";
import { Helpers_classList } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { Infra_urlForMediaImgSafe, Infra_urlForMedia } from "../shared/Shared.fs.js";
import { urlForResultsIframe, splitByLines, fileOnChangeForS3 } from "./Common.fs.js";
import { Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { singleton as singleton_1 } from "./fable_modules/fable-library.4.10.0/List.js";
import { value as value_2, map, defaultArg } from "./fable_modules/fable-library.4.10.0/Option.js";
import { player, playerEx } from "./ReactPlayer.fs.js";
import { int32ToString, equals } from "./fable_modules/fable-library.4.10.0/Util.js";
import { play_safe } from "./infra.js";
import { toString, fromParts, equals as equals_1 } from "./fable_modules/fable-library.4.10.0/Decimal.js";

export function termsOfUse(dispatch, acceptMsg, cancelMsg) {
    let props_18, children_18, children_6, children_10, props_8, children_16;
    const children_20 = [react.createElement("div", {
        className: "modal-background",
    }), (props_18 = [new HTMLAttr(65, ["modal-card"]), ["style", {
        height: "70%",
        width: "80%",
    }]], (children_18 = [(children_6 = [react.createElement("p", {
        className: "modal-card-title",
    }, "Welcome to Open Quiz production area!"), react.createElement("button", {
        className: "delete",
        "aria-label": "close",
        onClick: (_arg) => {
            dispatch(cancelMsg);
        },
    })], react.createElement("header", {
        className: "modal-card-head",
    }, ...children_6)), (children_10 = [(props_8 = [new HTMLAttr(149, ["/terms.html"]), ["style", {
        width: "100%",
        height: "100%",
    }]], react.createElement("iframe", keyValueList(props_8, 1)))], react.createElement("section", {
        className: "modal-card-body",
    }, ...children_10)), (children_16 = [react.createElement("button", {
        className: "button is-black has-text-danger",
        onClick: (_arg_1) => {
            dispatch(acceptMsg);
        },
    }, "Accept"), react.createElement("button", {
        className: "button",
        onClick: (_arg_2) => {
            dispatch(cancelMsg);
        },
    }, "Cancel")], react.createElement("footer", {
        className: "modal-card-foot",
    }, ...children_16))], react.createElement("div", keyValueList(props_18, 1), ...children_18)))];
    return react.createElement("div", {
        className: "modal is-active",
    }, ...children_20);
}

export function inputModal(dispatch, title, txt, changeMsg, okMsg, cancelMsg) {
    let children_14, children_4, children_6, children_12, props_10;
    const children_16 = [react.createElement("div", {
        className: "modal-background",
    }), (children_14 = [(children_4 = [react.createElement("p", {
        className: "modal-card-title",
    }, title)], react.createElement("header", {
        className: "modal-card-head",
    }, ...children_4)), (children_6 = [react.createElement("input", {
        className: "input",
        autoFocus: true,
        ref: (e) => {
            Internal_updateInputValue(txt, e);
        },
        onChange: (ev) => {
            dispatch(changeMsg(ev.target.value));
        },
    })], react.createElement("section", {
        className: "modal-card-body",
    }, ...children_6)), (children_12 = [(props_10 = [new HTMLAttr(65, ["button"]), new HTMLAttr(79, [txt === ""]), new DOMAttr(40, [(_arg) => {
        dispatch(okMsg);
    }])], react.createElement("button", keyValueList(props_10, 1), "Ok")), react.createElement("button", {
        className: "button",
        onClick: (_arg_1) => {
            dispatch(cancelMsg);
        },
    }, "Cancel")], react.createElement("footer", {
        className: "modal-card-foot",
    }, ...children_12))], react.createElement("div", {
        className: "modal-card",
    }, ...children_14))];
    return react.createElement("div", {
        className: "modal is-active",
    }, ...children_16);
}

export function imgArea$0027(style, tag, disabled, changeMsg, clearMsg, mediaHost, imgKey, defaultImg, clearText) {
    return toList(delay(() => {
        let props_2, children, props, props_6, children_2;
        return append(!isNullOrWhiteSpace(imgKey) ? singleton((props_2 = [Helpers_classList([["image", true], [style, true]]), ["style", {
            maxWidth: "320px",
        }]], (children = [(props = [new HTMLAttr(149, [Infra_urlForMedia(mediaHost, imgKey)])], react.createElement("img", keyValueList(props, 1)))], react.createElement("figure", keyValueList(props_2, 1), ...children)))) : (!isNullOrWhiteSpace(defaultImg) ? singleton((props_6 = [Helpers_classList([["image", true], [style, true]]), ["style", {
            maxWidth: "320px",
        }]], (children_2 = [react.createElement("img", {
            src: defaultImg,
        })], react.createElement("figure", keyValueList(props_6, 1), ...children_2)))) : empty()), delay(() => {
            let props_20, children_14, children_10, children_8, children_4, props_18;
            return singleton((props_20 = [new HTMLAttr(65, ["file"]), ["style", {
                marginTop: "8px",
            }]], (children_14 = [(children_10 = [react.createElement("input", {
                className: "file-input",
                type: "file",
                name: "picture",
                disabled: disabled,
                onChange: (ev) => {
                    fileOnChangeForS3(tag, changeMsg, ev);
                },
            }), (children_8 = [(children_4 = [Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-upload"])), [])], react.createElement("span", {
                className: "file-icon",
            }, ...children_4)), react.createElement("span", {
                className: "file-label",
            }, "Choose a file…")], react.createElement("span", {
                className: "file-cta",
            }, ...children_8))], react.createElement("label", {
                className: "file-label",
            }, ...children_10)), (props_18 = [new HTMLAttr(65, ["button"]), new HTMLAttr(79, [disabled]), ["style", {
                marginLeft: "5px",
            }], new DOMAttr(40, [(_arg) => {
                clearMsg();
            }])], react.createElement("button", keyValueList(props_18, 1), clearText))], react.createElement("div", keyValueList(props_20, 1), ...children_14))));
        }));
    }));
}

export function imgArea128(tag, disabled, changeMsg, clearMsg, mediaHost, imgKey, defaultImg, clearText) {
    return imgArea$0027("is-128x128", tag, disabled, changeMsg, clearMsg, mediaHost, imgKey, defaultImg, clearText);
}

export function imgEl(mediaHost, imgKey) {
    return delay(() => {
        let props_2, children, props;
        return !isNullOrWhiteSpace(imgKey) ? singleton((props_2 = [new HTMLAttr(65, ["image"]), ["style", {
            maxWidth: "320px",
            display: "inline-block",
        }]], (children = [(props = [new HTMLAttr(149, [Infra_urlForMedia(mediaHost, imgKey)])], react.createElement("img", keyValueList(props, 1)))], react.createElement("figure", keyValueList(props_2, 1), ...children)))) : empty();
    });
}

export function mediaArea(tag, disabled, urlMsg, mediaMsg, changeMsg, clearMsg, mediaHost, media, clearText) {
    return toList(delay(() => {
        let matchValue, matchValue_1, props_2, children;
        const url = defaultArg(map((m) => Infra_urlForMedia(mediaHost, m.Key), media), "");
        return append((matchValue = media, (matchValue == null) ? (empty()) : ((matchValue_1 = matchValue.Type, (matchValue_1.tag === 1) ? singleton(playerEx(false, false, url)) : ((matchValue_1.tag === 2) ? singleton(playerEx(true, false, url)) : singleton((props_2 = [new HTMLAttr(65, ["image"]), ["style", {
            maxWidth: "320px",
        }]], (children = [react.createElement("img", {
            src: url,
        })], react.createElement("figure", keyValueList(props_2, 1), ...children)))))))), delay(() => {
            let children_14, children_12, children_10, props_6, props_8, props_10, props_12;
            return append(singleton((children_14 = [react.createElement("input", {
                className: "input is-link is-small",
                type: "text",
                placeholder: "Media Url",
                ref: (e) => {
                    Internal_updateInputValue(url, e);
                },
                onChange: (ev) => {
                    urlMsg(ev.target.value);
                },
            }), (children_12 = [(children_10 = [(props_6 = [new HTMLAttr(143, [media == null])], react.createElement("option", keyValueList(props_6, 1), "...")), (props_8 = [new HTMLAttr(143, [(media != null) && (media.Type.tag === 0)])], react.createElement("option", keyValueList(props_8, 1), "picture")), (props_10 = [new HTMLAttr(143, [(media != null) && (media.Type.tag === 1)])], react.createElement("option", keyValueList(props_10, 1), "audio")), (props_12 = [new HTMLAttr(143, [(media != null) && (media.Type.tag === 2)])], react.createElement("option", keyValueList(props_12, 1), "video"))], react.createElement("select", {
                onChange: (ev_1) => {
                    mediaMsg(ev_1.target.value);
                },
            }, ...children_10))], react.createElement("div", {
                className: "select is-small",
            }, ...children_12))], react.createElement("div", {
                className: "field has-addons",
            }, ...children_14))), delay(() => {
                let props_32, children_26, children_22, children_20, children_16, props_30;
                return singleton((props_32 = [new HTMLAttr(65, ["file"]), ["style", {
                    marginTop: "8px",
                }]], (children_26 = [(children_22 = [react.createElement("input", {
                    className: "file-input",
                    type: "file",
                    name: "picture",
                    disabled: disabled,
                    onChange: (ev_2) => {
                        fileOnChangeForS3(tag, changeMsg, ev_2);
                    },
                }), (children_20 = [(children_16 = [Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-upload"])), [])], react.createElement("span", {
                    className: "file-icon",
                }, ...children_16)), react.createElement("span", {
                    className: "file-label",
                }, "Choose a file…")], react.createElement("span", {
                    className: "file-cta",
                }, ...children_20))], react.createElement("label", {
                    className: "file-label",
                }, ...children_22)), (props_30 = [new HTMLAttr(65, ["button"]), new HTMLAttr(79, [disabled]), ["style", {
                    marginLeft: "5px",
                }], new DOMAttr(40, [(_arg) => {
                    clearMsg();
                }])], react.createElement("button", keyValueList(props_30, 1), clearText))], react.createElement("div", keyValueList(props_32, 1), ...children_26))));
            }));
        }));
    }));
}

export function mediaEl(mediaHost, media, isPlaying) {
    return delay(() => {
        let props_2, children;
        if (media == null) {
            return empty();
        }
        else {
            const media_1 = media;
            const url = Infra_urlForMedia(mediaHost, media_1.Key);
            const matchValue = media_1.Type;
            return (matchValue.tag === 1) ? singleton(playerEx(false, isPlaying, url)) : ((matchValue.tag === 2) ? singleton(playerEx(true, isPlaying, url)) : singleton((props_2 = [new HTMLAttr(65, ["image"]), ["style", {
                maxWidth: "320px",
                display: "inline-block",
            }]], (children = [react.createElement("img", {
                src: url,
            })], react.createElement("figure", keyValueList(props_2, 1), ...children)))));
        }
    });
}

export const footer = (() => {
    const props_10 = [new HTMLAttr(65, ["container"]), ["style", {
        textAlign: "center",
    }]];
    const children_10 = ["©", react.createElement("span", {
        className: "is-hidden-touch",
    }, " Serhii Sabirov"), " 2020/25", " - ", react.createElement("a", {
        href: "/terms.html",
        className: "has-text-grey-light",
    }, "Terms"), " - ", react.createElement("a", {
        href: "/disclaimer.html",
        className: "has-text-grey-light",
    }, "Disclaimer"), " - ", react.createElement("a", {
        href: "/privacy-policy-en.html",
        className: "has-text-grey-light",
    }, "Privacy"), " - ", react.createElement("a", {
        href: "https://t.me/open_quiz",
        className: "has-text-grey-light",
    }, "Contact")];
    return react.createElement("div", keyValueList(props_10, 1), ...children_10);
})();

export const footerHero = react.createElement("div", {
    className: "hero-foot has-background-dark has-text-grey-light",
}, footer);

export const footerFixed = (() => {
    const props = [new HTMLAttr(65, ["has-background-dark has-text-grey-light"]), ["style", {
        position: "fixed",
        bottom: "0",
        height: "22px",
        width: "100%",
        overflowX: "hidden",
    }]];
    return react.createElement("div", keyValueList(props, 1), footer);
})();

export function playFooter(dispatch, history, questions, results, current, isCountdownActive, secondsLeft, l10n) {
    let children_18, children_16, props_2, children_2, props_10, children_10, props_8, children_8, props_14, children_14;
    const isLastCall = isCountdownActive && (secondsLeft <= 10);
    const props_20 = [["style", {
        position: "fixed",
        bottom: "0",
        height: "62px",
        width: "100%",
        backgroundColor: "#FFFFFF",
        overflowX: "hidden",
    }]];
    const children_20 = [(children_18 = [(children_16 = [(props_2 = [Helpers_classList([["has-text-weight-bold", equals(current, history)]])], (children_2 = [react.createElement("a", {
        onClick: (_arg) => {
            dispatch(history);
        },
    }, l10n.MenuHistory)], react.createElement("li", keyValueList(props_2, 1), ...children_2))), (props_10 = [Helpers_classList([["has-text-weight-bold", equals(current, questions)]]), ["style", {
        height: "100%",
        width: "33%",
    }]], (children_10 = [(props_8 = [["style", {
        height: "100%",
        justifyContent: isLastCall ? "left" : "center",
        padding: "0",
    }], new DOMAttr(40, [(_arg_1) => {
        dispatch(questions);
    }])], (children_8 = toList(delay(() => {
        let copyOfStruct, props_6, arg, children_6, props_4;
        return isCountdownActive ? ((secondsLeft > 10) ? singleton((copyOfStruct = (secondsLeft - 10), int32ToString(copyOfStruct))) : singleton((props_6 = [new HTMLAttr(65, ["has-background-danger"]), ["style", {
            height: "100%",
            width: (arg = ((((10 - secondsLeft) + 1) * 10) | 0), toText(printf("%i%%"))(arg)),
        }]], (children_6 = [(props_4 = [new HTMLAttr(65, ["is-overlay has-text-weight-bold"]), ["style", {
            padding: "12px",
        }]], react.createElement("span", keyValueList(props_4, 1), l10n.MenuLastCall))], react.createElement("div", keyValueList(props_6, 1), ...children_6))))) : singleton(l10n.MenuQuestion);
    })), react.createElement("a", keyValueList(props_8, 1), ...children_8)))], react.createElement("li", keyValueList(props_10, 1), ...children_10))), (props_14 = [Helpers_classList([["has-text-weight-bold", equals(current, results)]])], (children_14 = [react.createElement("a", {
        onClick: (_arg_2) => {
            dispatch(results);
        },
    }, l10n.MenuResults)], react.createElement("li", keyValueList(props_14, 1), ...children_14)))], react.createElement("ul", {}, ...children_16))], react.createElement("div", {
        className: "tabs is-white is-large is-toggle is-fullwidth",
    }, ...children_18))];
    return react.createElement("div", keyValueList(props_20, 1), ...children_20);
}

export function playSounds(mediaHost, secondsLeft) {
    if (secondsLeft === 11) {
        play_safe("/chgk2-sig2.mp3");
    }
    if (secondsLeft === 1) {
        play_safe("/chgk2-sig3.mp3");
    }
}

export function playTitle(mediaHost, quizImg, mixlr, url) {
    const props_16 = [["style", {
        margin: "5px",
    }]];
    const children_10 = toList(delay(() => {
        let props_6, children_6, props_4, children_2, children;
        if (url == null) {
            const matchValue = mixlr;
            if (matchValue == null) {
                return append(singleton(react.createElement("br", {})), delay(() => {
                    let props_12, children_8, props_10;
                    return append(singleton((props_12 = [new HTMLAttr(65, ["image is-128x128"]), ["style", {
                        display: "inline-block",
                    }]], (children_8 = [(props_10 = [new HTMLAttr(149, [Infra_urlForMediaImgSafe(mediaHost, quizImg)])], react.createElement("img", keyValueList(props_10, 1)))], react.createElement("figure", keyValueList(props_12, 1), ...children_8)))), delay(() => singleton(react.createElement("br", {}))));
                }));
            }
            else {
                const mixlrCode = value_2(matchValue);
                return singleton((props_6 = [["style", {
                    width: "100%",
                    height: "100px",
                    overflowStyle: "hidden",
                    position: "relative",
                }]], (children_6 = [(props_4 = [new HTMLAttr(149, [`https://${mixlrCode}.mixlr.com/embed`]), ["style", {
                    width: "100%",
                    height: "200px",
                    transform: "scale(0.5)",
                    transformOrigin: "top",
                }], new HTMLAttr(89, ["0"]), new HTMLAttr(141, ["no"]), new HTMLAttr(112, [0]), new HTMLAttr(113, [0])], react.createElement("iframe", keyValueList(props_4, 1)))], react.createElement("div", keyValueList(props_6, 1), ...children_6))));
            }
        }
        else {
            return singleton((children_2 = [(children = [player(url)], react.createElement("div", {
                className: "has-ratio",
            }, ...children))], react.createElement("figure", {
                className: "image is-16by9",
            }, ...children_2)));
        }
    }));
    return react.createElement("div", keyValueList(props_16, 1), ...children_10);
}

export function playQuiz(status, msg, l10n) {
    let children, children_2;
    const children_4 = [(children = toList(delay(() => {
        switch (status.tag) {
            case 0:
                return singleton(l10n.QuizIsNotStarted);
            case 2:
                return singleton(l10n.QuizIsNotFinished);
            default: {
                return empty();
            }
        }
    })), react.createElement("p", {
        className: "subtitle is-5",
    }, ...children)), (children_2 = splitByLines(msg), react.createElement("p", {}, ...children_2))];
    return react.createElement("div", {
        className: "notification is-white",
    }, ...children_4);
}

export function singleTourInfo(mediaHost, tourName, slip, l10n) {
    const children_16 = toList(delay(() => {
        let children;
        return append(singleton((children = [(l10n.Question + " ") + tourName], react.createElement("h5", {
            className: "title is-5",
        }, ...children))), delay(() => {
            let matchValue, slip_1, children_4, children_2, arg, slip_2;
            return append((matchValue = slip, (matchValue.tag === 1) ? ((slip_1 = matchValue.fields[0], append(!equals_1(slip_1.Points, fromParts(1, 0, 0, false, 0)) ? singleton((children_4 = [(children_2 = [(arg = toString(slip_1.Points), toText(printf("%s %s"))(arg)(l10n.PointsSmall))], react.createElement("span", {
                className: "tag",
            }, ...children_2))], react.createElement("p", {}, ...children_4))) : empty(), delay(() => append(mediaEl(mediaHost, slip_1.Media, true), delay(() => {
                let children_6;
                return singleton((children_6 = splitByLines(slip_1.Txt), react.createElement("p", {
                    className: "has-text-weight-semibold",
                }, ...children_6)));
            })))))) : ((matchValue.tag === 2) ? ((slip_2 = matchValue.fields[0], append(mediaEl(mediaHost, slip_2.Media, true), delay(() => {
                let matchValue_1;
                return append((matchValue_1 = slip_2.Aw, (matchValue_1.tag === 1) ? (empty()) : append(singleton(react.createElement("p", {
                    className: "has-text-weight-bold",
                }, l10n.Answer)), delay(() => {
                    let children_10;
                    return singleton((children_10 = splitByLines(matchValue_1.fields[0]), react.createElement("p", {
                        className: "has-text-weight-semibold",
                    }, ...children_10)));
                }))), delay(() => ((slip_2.Com !== "") ? append(singleton(react.createElement("p", {
                    className: "has-text-weight-bold",
                }, l10n.Comment)), delay(() => {
                    let children_14;
                    return singleton((children_14 = splitByLines(slip_2.Com), react.createElement("p", {}, ...children_14)));
                })) : empty())));
            })))) : (empty()))), delay(() => singleton(react.createElement("br", {}))));
        }));
    }));
    return react.createElement("div", {}, ...children_16);
}

export function resultsViewEmb$0027(full, quizId, resultsToken, teamId, mediaHost) {
    const props_2 = [new HTMLAttr(65, ["content"]), ["style", {}]];
    const children_2 = toList(delay(() => {
        let props;
        const height = full ? "80vh" : "60vh";
        return singleton((props = [new HTMLAttr(149, [urlForResultsIframe(quizId, resultsToken, teamId, mediaHost)]), ["style", {
            width: "100%",
            height: height,
            overflowX: "visible",
            overflowY: "visible",
        }]], react.createElement("iframe", keyValueList(props, 1))));
    }));
    return react.createElement("div", keyValueList(props_2, 1), ...children_2);
}

export const resultsViewEmb = (quizId) => ((resultsToken) => ((teamId) => ((mediaHost) => resultsViewEmb$0027(false, quizId, resultsToken, teamId, mediaHost))));

export function deleteForm(dispatch, placeholder, validText, inputText, isSending, error, toggleMsg, updateMsg, deleteMsg) {
    let props_12, children_10, children, children_4, props_4, children_8, props_8;
    const children_14 = [(props_12 = [new HTMLAttr(65, ["field has-addons"]), ["style", {
        paddingBottom: "5px",
    }]], (children_10 = [(children = [react.createElement("input", {
        className: "input",
        disabled: isSending,
        type: "text",
        placeholder: placeholder,
        maxLength: 128,
        ref: (e) => {
            Internal_updateInputValue(inputText, e);
        },
        onChange: (ev) => {
            dispatch(updateMsg(ev.target.value));
        },
    })], react.createElement("p", {
        className: "control is-expanded",
    }, ...children)), (children_4 = [(props_4 = [Helpers_classList([["button", true], ["has-text-danger", true], ["has-text-weight-semibold", true], ["is-loading", isSending]]), new HTMLAttr(79, [inputText !== validText]), new DOMAttr(40, [(_arg) => {
        dispatch(deleteMsg);
    }])], react.createElement("button", keyValueList(props_4, 1), "Delete"))], react.createElement("p", {
        className: "control",
    }, ...children_4)), (children_8 = [(props_8 = [Helpers_classList([["button", true]]), new DOMAttr(40, [(_arg_1) => {
        dispatch(toggleMsg);
    }])], react.createElement("button", keyValueList(props_8, 1), "Cancel"))], react.createElement("p", {
        className: "control",
    }, ...children_8))], react.createElement("div", keyValueList(props_12, 1), ...children_10))), react.createElement("p", {
        className: "help is-danger",
    }, error)];
    return react.createElement("div", {}, ...children_14);
}

export function errors(dispatch, msg, errors_1) {
    const children_4 = toList(delay(() => map_1((error) => {
        const children_2 = [react.createElement("button", {
            className: "delete",
            onClick: (_arg) => {
                dispatch(msg(error[0]));
            },
        }), error[1]];
        return react.createElement("div", {
            className: "notification is-danger is-light",
        }, ...children_2);
    }, errors_1)));
    return react.createElement("div", {}, ...children_4);
}

